import React, { FC } from 'react';
import CompanyDetail, { getServerSideProps as gSSP } from '../../components/pages/CompanyDetail';

const Onderneming: FC<React.PropsWithChildren<unknown>> = () => <CompanyDetail />;

export default Onderneming;

export const getServerSideProps = gSSP;
